import { FunctionComponent } from 'react';
import PropertyTabs from './PropertyTabs';

const ViewProperty: FunctionComponent<any> = () => <PropertyTabs />;

export default ViewProperty;
